import { GoldBorderCursive } from './GoldBorderCursive';

export default GoldBorderCursive;
